import React from "react";
import NascarProjections from "./NascarProjections";

export default function CupProjections() {
  return <NascarProjections series="cup" />;
}
